/* eslint-disable @typescript-eslint/no-explicit-any */
import { QUESTION_NEW_CARS, QUESTION_USED_CARS } from './utils.question';
import { toBase64, toUrlDisplayNamePath } from './utils.url';

export const OFFER_STATUS = {
  FR: 'FR',
  FR1: 'FR1',
  FR2: 'FR2',
  CLEARED: 'CLEARED',
  INSPECTION: 'INSPECTION',
  INELIGIBLE: 'INELIGIBLE',
};

export const UNASSIGNED_OFFER_CODES = {
  CMB: 'CMB',
  B: 'B',
  N: 'N',
  KBM: 'KBM',
};

export const ASSIGNED_OFFER_CODES = {
  A: 'A',
  CML: 'CML',
  KBI: 'KBI',
  W: 'W',
  CMW: 'CMW',
  K: 'K',
  I: 'I',
  DI: 'DI',
  C1: 'C1',
  C2: 'C2',
  C3: 'C3',
  SI: 'SI',
  SL: 'SL',
};

export const DIGITAL_RETAILING_OFFER_CODES = {
  D: 'D',
};

export const COBRANDING_OFFER_CODES = {
  OC: 'OC',
  WC: 'WC',
};

export const KBYC_DEALER = {
  GUID: '5ee92276-44b4-47e6-b707-53a1b3344d4b',
};

export const DISPOSAL_TYPES = {
  ICO: 'ICO',
  KBYC: 'KBYC',
  ICOANDKBYC: 'ICOANDKBYC',
  ICOANDKBYCFAKE: 'ICOANDKBYCFAKE',
};

export const calculateDealerBoost = (markupAmounts = {}) => {
  const markupsByDealer = Object.keys(markupAmounts);
  const firstMarkup = markupAmounts[markupsByDealer[0]];

  return firstMarkup || 0;
};

export const cleanAnswersForAPI = (questionSet = {}) => {
  const questionEntries = Object.entries(questionSet);
  return questionEntries
    .filter(([_, answer]: [string, any]) => answer.isRequired || answer.value || answer.value === 0)
    .map(([questionId, answer]: [string, any]) => {
      if (answer.comment) {
        return { questionId, value: answer.value, comment: answer.comment, type: answer.type };
      }
      return { questionId, value: answer.value, type: answer.type };
    });
};

export const removeNotNeededAnswers = (questions = [], questionIds = []) => {
  return questions.reduce((acc, q) => {
    if (!questionIds.includes(q.questionId)) {
      return [...acc, q];
    }
    return acc;
  }, []);
};

export const removeInvalidAnswers = (rvLookingForOptions, rvAnswers) => {
  let updatedList = [...rvAnswers];
  const questions = [QUESTION_USED_CARS, QUESTION_NEW_CARS];
  questions.forEach((question) => {
    if (!rvLookingForOptions.some((item) => item.qRef === question)) {
      updatedList = updatedList.filter((item) => item.questionId !== question);
    }
  });
  return updatedList;
};

export const getExpiredOfferSubmitRedirectUrl = (offerId, year, make, model, vin, mileage) => {
  const pathAry = [process.env.FURY_URL, 'instant-cash-offer', year, toUrlDisplayNamePath(make), toUrlDisplayNamePath(model)];
  // create string to encode
  const jsonStr = JSON.stringify({ ...{ vin }, p: 0, lp: 1, pa: ['offer', offerId], m: mileage });
  return `${pathAry.join('/')}#_____${toBase64(jsonStr)}`;
};

export const isUnderReview = (status) => {
  const reviewStatus = ['kbbReviewNBH', 'FR', 'INSPECTION'];

  return reviewStatus.includes(status);
};

export const formatPrice = (price) => {
  if (price) {
    return `$${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }

  return price;
};

export const formatOfferExpiration = (expirationDate) => {
  const offerExpiration = expirationDate ? expirationDate.split('T')[0].split('-') : undefined;
  const formatedExpiration = offerExpiration && `${offerExpiration[1]}/${offerExpiration[2]}/${offerExpiration[0]}`;
  return formatedExpiration;
};

export const dealerBoostFormatted = (markupAmounts) => {
  const dealerBoost = calculateDealerBoost(markupAmounts);
  return dealerBoost ? formatPrice(dealerBoost) : dealerBoost;
};
